import { create } from "zustand";

// ─── Constants ──────────────────────────────────────────────────────────────

const LAST_SEEN_RELEASE_DATE_KEY = "lastSeenReleaseNotesDate";

// ─── Types ──────────────────────────────────────────────────────────────────

export interface ReleaseNote {
  date: string;
  content: string;
}

interface ReleaseNotesStore {
  releaseNote: ReleaseNote | null;
  hasNewReleaseNote: boolean;
  setReleaseNote: (note: ReleaseNote) => void;
  markAsSeen: () => void;
  getLastSeenDate: () => string | null;
}

// ─── Store ──────────────────────────────────────────────────────────────────

const useReleaseNotesStore = create<ReleaseNotesStore>((set, get) => ({
  releaseNote: null,
  hasNewReleaseNote: false,

  setReleaseNote: (note) => {
    const lastSeenDate = get().getLastSeenDate();
    const isNew = !lastSeenDate || note.date > lastSeenDate;

    set({
      releaseNote: note,
      hasNewReleaseNote: isNew,
    });
  },

  markAsSeen: () => {
    const note = get().releaseNote;
    if (note) {
      try {
        localStorage.setItem(LAST_SEEN_RELEASE_DATE_KEY, note.date);
      } catch {
        // localStorage unavailable — silently ignore
      }
    }
    set({ hasNewReleaseNote: false });
  },

  getLastSeenDate: () => {
    try {
      return localStorage.getItem(LAST_SEEN_RELEASE_DATE_KEY);
    } catch {
      return null;
    }
  },
}));

export default useReleaseNotesStore;
